(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var easing = 'cubic-bezier(0.86, 0, 0.07, 1)';

  var glassTransition = {
    _parts: function () {
      return {
        overlay: this.shadowRoot.querySelector('[part="overlay"]'),
        content: this.shadowRoot.querySelector('[part="content"]')
      };
    },

    _run: function (animations, animate) {
      if (!animate) {
        animations.forEach(function (a) { a.finish(); });
      }
      return Promise.all(animations.map(function (a) { return a.finished; }));
    },

    _reset: function (parts) {
      var targets = [parts.overlay, parts.content].concat(Array.prototype.slice.call(parts.content.children));
      targets.forEach(function (el) {
        el.getAnimations().forEach(function (a) { a.cancel(); });
      });
    },

    _showTransition: function (animate) {
      var parts = this._parts();
      this._reset(parts);
      this._setInitialPosition();
      this.style.visibility = 'visible';
      this.style.opacity = '1';

      var animations = [
        parts.overlay.animate({ opacity: [0, 1] }, { duration: 150, fill: 'both' })
      ];

      if (reduceMotion) {
        animations.push(parts.content.animate({ opacity: [0, 1] }, { duration: 200, fill: 'both' }));
      } else {
        animations.push(parts.content.animate({ clipPath: this._getClipPathProperties() }, { duration: 400, delay: 150, easing: easing, fill: 'both' }));
        Array.prototype.forEach.call(parts.content.children, function (child) {
          animations.push(child.animate({ opacity: [0, 1] }, { duration: 150, delay: 550, fill: 'both' }));
        });
      }

      return this._run(animations, animate !== false).then(function () {
        this.classList.add('show-close-cursor');
      }.bind(this));
    },

    _hideTransition: function () {
      var parts = this._parts();
      this._reset(parts);
      var animations = [];

      if (reduceMotion) {
        animations.push(parts.content.animate({ opacity: [1, 0] }, { duration: 200, fill: 'both' }));
        animations.push(parts.overlay.animate({ opacity: [1, 0] }, { duration: 200, fill: 'both' }));
      } else {
        Array.prototype.forEach.call(parts.content.children, function (child) {
          animations.push(child.animate({ opacity: [1, 0] }, { duration: 150, fill: 'both' }));
        });
        animations.push(parts.content.animate({ clipPath: this._getClipPathProperties().reverse() }, { duration: 400, delay: 150, easing: easing, fill: 'both' }));
        animations.push(parts.overlay.animate({ opacity: [1, 0] }, { duration: 150, delay: 550, fill: 'both' }));
      }

      return this._run(animations, true).then(function () {
        this.style.visibility = 'hidden';
        this.classList.remove('show-close-cursor');
      }.bind(this));
    }
  };

  function defineSetDrawer(BaseDrawer) {
    if (window.customElements.get('set-drawer')) {
      return;
    }

    class SetDrawer extends BaseDrawer {}
    Object.assign(SetDrawer.prototype, glassTransition);

    window.customElements.define('set-drawer', SetDrawer);
  }

  function patchGlassTransition(ElementClass) {
    if (!ElementClass || ElementClass.prototype.nbdcGlassTransition) {
      return;
    }

    Object.assign(ElementClass.prototype, glassTransition);
    ElementClass.prototype.nbdcGlassTransition = true;
  }

  function whenDefined(name, callback) {
    var existing = window.customElements.get(name);

    if (existing) {
      callback(existing);
      return;
    }

    window.customElements.whenDefined(name).then(function () {
      callback(window.customElements.get(name));
    });
  }

  whenDefined('x-drawer', defineSetDrawer);
  whenDefined('cart-drawer', patchGlassTransition);
})();
